"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdSetSkadResponseToJSON = exports.AdSetSkadResponseFromJSONTyped = exports.AdSetSkadResponseFromJSON = exports.instanceOfAdSetSkadResponse = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the AdSetSkadResponse interface.
 */
function instanceOfAdSetSkadResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfAdSetSkadResponse = instanceOfAdSetSkadResponse;
function AdSetSkadResponseFromJSON(json) {
    return AdSetSkadResponseFromJSONTyped(json, false);
}
exports.AdSetSkadResponseFromJSON = AdSetSkadResponseFromJSON;
function AdSetSkadResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'appId': !(0, runtime_1.exists)(json, 'app_id') ? undefined : json['app_id'],
        'adSetId': !(0, runtime_1.exists)(json, 'ad_set_id') ? undefined : json['ad_set_id'],
        'skadEnabled': !(0, runtime_1.exists)(json, 'skad_enabled') ? undefined : json['skad_enabled'],
        'skadNetworkError': !(0, runtime_1.exists)(json, 'skad_network_error') ? undefined : json['skad_network_error'],
    };
}
exports.AdSetSkadResponseFromJSONTyped = AdSetSkadResponseFromJSONTyped;
function AdSetSkadResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'app_id': value.appId,
        'ad_set_id': value.adSetId,
        'skad_enabled': value.skadEnabled,
        'skad_network_error': value.skadNetworkError,
    };
}
exports.AdSetSkadResponseToJSON = AdSetSkadResponseToJSON;
